import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import style from "./UpsellBanner.module.css";
import Icon from "@/ui/icon/Icon";
import { formatPriceAmount } from "@/i18n/format";
import { useCurrentLanguage } from "@/i18n/useLocalized";

// The cheapest plan's daily price, as the banner has always quoted it.
const FROM_PRICE_PER_DAY = 0.27;

function UpsellBanner({ lockedCount }) {
	const { t } = useTranslation();
	const language = useCurrentLanguage();

	return (
		<div className={style.banner}>
			<div>
				<div className={style.headline}>
					{t("landing:upsell.headline", {
						count: lockedCount,
						price: formatPriceAmount(FROM_PRICE_PER_DAY, language),
					})}
				</div>
				<div className={style.sub}>{t("landing:upsell.sub")}</div>
			</div>
			<Link to="/plans" className={style.cta}>
				{t("landing:upsell.cta")}
				<Icon icon="fa-arrow-right" />
			</Link>
		</div>
	);
}

export default UpsellBanner;
